import { withFormik } from "formik";
import * as Yup from "yup";
import GREENTILL_STORE_THEME_DEFAULTS from "util/storeThemeDefaults";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    image: Yup.string()
      .required("Store logo is required")
      .nullable(),
    name: Yup.string()
      .required("Store name is required")
      .nullable(),
    storeDescription: Yup.string()
  }),
  mapPropsToValues: props => ({
    isActive: props.editedData ? props.editedData.active : false,
    storeLoyaltyPartner: props.editedData
      ? props?.editedData?.storeLoyaltyPartner
      : false,
    image: props.editedData ? props.editedData.storeLogo : "",
    name: props.editedData ? props.editedData.storeName : "",
    storeDescription: props?.editedData
      ? props?.editedData?.storeDescription
      : "",
    primaryColor:
      props?.editedData?.primaryColor ||
      GREENTILL_STORE_THEME_DEFAULTS.primaryColor,
    secondaryColor:
      props?.editedData?.secondaryColor ||
      GREENTILL_STORE_THEME_DEFAULTS.secondaryColor,
    sidebarColor:
      props?.editedData?.sidebarColor ||
      GREENTILL_STORE_THEME_DEFAULTS.sidebarColor,
    topbarColor:
      props?.editedData?.topbarColor ||
      GREENTILL_STORE_THEME_DEFAULTS.topbarColor,
    menuHighlightColor:
      props?.editedData?.menuHighlightColor ||
      GREENTILL_STORE_THEME_DEFAULTS.menuHighlightColor,
    menuTextColor:
      props?.editedData?.menuTextColor ||
      GREENTILL_STORE_THEME_DEFAULTS.menuTextColor,
    accentColor:
      props?.editedData?.accentColor ||
      GREENTILL_STORE_THEME_DEFAULTS.accentColor
  }),
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
